<template>
  <div id="opdashboard" class="p-grid">
    <div class="p-col-6 p-offset-3"></div>

    <h5>Upload New EQSIT from GCSS-Army using PM Global Variant</h5>
    <br />
    <div class="container">
      <FileUpload
        class="fileupload p-m-1"
        v-show="!uploading && !adminCreating"
        name="demo[]"
        chooseLabel="EQSIT JSON File"
        mode="basic"
        :auto="true"
        :customUpload="true"
        @uploader="onUpload($event)"
      />
      <div v-show="uploading">
        <ProgressBar :value="Math.round(progress)" />
      </div>
      <div v-show="adminCreating">
        <p>Creating Admin records</p>
        <ProgressBar :value="adminProgress" />
        <p>Completed: {{ completed }}</p>
        <Button @click="cancelAdmin()" label="Cancel" class="p-button-danger" />
      </div>
    </div>
    <br />
    <br />
    <br />
    <br />
    <h5>Upload New ESR from GCSS-Army using PM Global Variant</h5>
    <br />
        <div class="container">
      <FileUpload
        class="fileupload p-m-1"
        v-show="!uploading && !esrCreating"
        name="demo[]"
        chooseLabel="ESR JSON File"
        mode="basic"
        :auto="true"
        :customUpload="true"
        @uploader="onUpload($event)"
      />
      <div v-show="uploading">
        <ProgressBar :value="Math.round(progress)" />
      </div>
      <div v-show="esrCreating">
        <p>Creating ESR records</p>
        <ProgressBar :value="esrProgress" />
        <p>Completed: {{completed}}</p>
        <Button @click="cancelESR()" label="Cancel" class="p-button-danger" />
      </div>
    </div>
  </div>
</template>

<script>
import { fb_db, fb_storage, fb_bump } from "../firebase";
import adminData from "@/assets/admin.json";
import FileUpload from "primevue/fileupload";
import ProgressBar from "primevue/progressbar";
import axios from "axios";

export default {
  name: "UploadAdmin",
  components: {
    FileUpload,
    ProgressBar,
  },
  data() {
    return {
      progress: 0,
      adminProgress: 0,
      adminCreating: false,
      completed: 0,
      uploading: false,
      url: null,
      cancel: false,
    };
  },
  methods: {
    onUpload(e) {
      console.log("Uplaoding file....", e.files);
      this.uploading = true;
      let file = e.files[0];
      var uploadTask = fb_storage
        .child("uploads/admin-dump/" + file.name)
        .put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          this.progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + this.progress + "% done");
        },
        function (error) {
          // Handle unsuccessful uploads
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            console.log("File available at", downloadURL);
            // update some collection with this url
            // fb_db.collection('faults').doc('DVkYRdF9aNCQl2BMVUKS').update({
            //   image: downloadURL
            // })
            this.url = downloadURL;
            this.uploading = false;
            this.uploadAdmins();
          });
        }
      );
    },
    cancelAdmin() {
      this.cancel = true;
      setTimeout(() => {
        this.cancel = false;
      }, 3000);
    },
    async uploadAdmins() {
      this.adminCreating = true;
      await axios.post("cloud function url", this.url).then((response) => {
        console.log(response);
        this.adminCreating = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#opdashboard {
  color: #999999;

  .container {
    width: 100%;
  }
}
</style>